import { ComponentClass } from 'react';

import { EngineProps } from '../../renderer/react-renderer';

import bridge from './class-bridge';
import create from './stateful-component';

function ClassBridge(ComponentType: ComponentClass): ComponentClass<EngineProps> {
  const name = ComponentType.name;
  
  const StatefulComponent = create(`${name}[Stateful]`, ComponentType);
  
  return bridge(`ClassBridge[${name}]`, StatefulComponent);
}

export default ClassBridge;
